import React, { useState } from "react";
import DynamicModal from "../../../Modal/DynamicModal";
import './WmsLegend.css';

const WmsLegend = ({ layer }) => {
    const [showModal, setShowModal] = useState(false);

    const layerUrl = layer?.props?.data;
    const layerName = layer?.props?.id;

    const parseLayerName = (id) => {
        const parts = id.split("-");
        return parts.length > 1 ? parts[0] : id;
    };

    const parsedLayerName = parseLayerName(layerName);

    if (!layerUrl || !parsedLayerName) return null;

    const legendUrl = `${layerUrl}?service=WMS&version=1.1.1&request=GetLegendGraphic&format=image/png&layer=${parsedLayerName}`;

    return (
        <div className="legend-preview-wrapper">
            <label className="legend-label">Legenda:</label>

            <div
                className="legend-preview"
                onClick={() => setShowModal(true)}
                title="Klikni za uvećani prikaz"
            >
                <img
                    src={legendUrl}
                    alt={`Legenda za sloj ${parsedLayerName}`}
                />
            </div>

            <DynamicModal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)}
                title={`Legenda za sloj: ${parsedLayerName}`}
                customWidth="500px"
                customHeight="500px"
                customZIndex={10000}
                centered={true}
                mainContent={
                    <img
                        src={legendUrl}
                        alt="Uvećana legenda"
                        className="legend-full-image"
                    />
                }
                footerContent={
                    <button
                        onClick={() => setShowModal(false)}
                        className="app-btn app-btn-secondary"
                    >
                        Zatvori
                    </button>
                }
            />
        </div>
    );
};

export default WmsLegend;